/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, nthChildIterator, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED CONTENT : STYLES --------------- ++++++++++ */
export default theme => ({
	embedcontent: {
		'& .cards': {
			// overflow: 'hidden',
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'flex-start',
			justifyContent: 'flex-start',
			margin: replacePXinStringWithEM(`10px 0 10px`),
			position: 'relative',
			zIndex: 1,
			'& .contentanalyticscard': {
				marginBottom: pxToEm(15),
				// marginRight: '0.5%',
				// marginLeft: '0.5%',
				// width: '24%',
				marginRight: '0.65%',
				marginLeft: '0.65%',
				width: '32%',
				transition: 'all .2s linear 0s',

				// animate in
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
				extend: nthChildIterator(100, .3, .05),
			}
		},
		// ..... CONTROLBAR ..... //
		'& .controlbar': {
			opacity: '0',
			animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.2s',
			position: 'relative',
			zIndex: 2,
			'& .name-nameTitle':{
				'& .selected':{
					fontSize: pxToEm(14)
				}
			},
		},
		'& .pager': {
			textAlign: 'center'
		}
	},

	[mediaQuery.thinnest]: {
		embedcontent: {
			'& .cards': {
				'& .contentanalyticscard': {
					width: '100%',
					marginRight: '0 !important'
				}
			}
		}
	}
});
